export default __webpack_public_path__ + "static/deciduous-champion-e215368f90af00decbd8956511e928a1.png";